export const isMessageWithSections = message => {
  return message.displayType === 'SECTIONS';
};
export const isActionButtonV2 = actionButtonObj => {
  return (actionButtonObj === null || actionButtonObj === void 0 ? void 0 : actionButtonObj.type) === 'ACTION_V2';
};